import React from "react";

const Details = ({ rowData }) => {
  if (!rowData) return <p>No data available</p>;

  const fields = [
    { label: "ID", key: "id" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Network Status", key: "networkStatus" },
    { label: "Overall Health", key: "overallHealth" },
    { label: "Card Dispenser", key: "cardDispenser" },
    { label: "Cash Acceptor", key: "cashAcceptor" },
    { label: "Receipt Printer", key: "receiptPrinter" },
    { label: "Total Operations", key: "totalOperations" },
    { label: "Successful Operations", key: "successOperations" },
    { label: "Failed Operations", key: "failedOperations" },
    { label: "Created Date", key: "createdDate" },
    { label: "Last Updated", key: "lastUpdated" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key }) => (
          <div key={key} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{rowData[key] || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
